import { doc } from 'firebase/firestore';

import { db } from '../services/firebase.js';

export const getLearningProgressPath = (userId, level, chapter) =>
    `users/${userId}/level_${level}/chapter_${chapter}/Learn/LearningProgress`;

export const getMasteryPath = (userId, level, chapter) =>
    `users/${userId}/level_${level}/chapter_${chapter}/Learn/Mastery`;

export const getLearningProgressRef = (userId, level, chapter) =>
    doc(db, getLearningProgressPath(userId, level, chapter));

export const getMasteryRef = (userId, level, chapter) =>
    doc(db, getMasteryPath(userId, level, chapter));
